import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { withTranslation } from "react-i18next";

import moment from "moment";
import { get } from "lodash";

import { Col, Row } from "reactstrap";

import Collapse from "Components/Common/ViewApplicationDetailComponents/Collapse";

const ViewMockScheduleData = ({ mockDrillData, isExpandable = true, t }) => {
  const { mockDrillConductedOn, nextMockDrillDueOn } = mockDrillData;

  const fields = useMemo(
    () => [
      {
        name: "Building Name",
        key: "developerBuilding.name",
        isRequired: true,
      },
      {
        name: "MockDrill Conducted On",
        renderField: () =>
          mockDrillConductedOn
            ? moment(mockDrillConductedOn).format("DD-MM-YYYY")
            : "N/A",
      },
      {
        name: "Next MockDrill Due On",
        renderField: () =>
          nextMockDrillDueOn
            ? moment(nextMockDrillDueOn).format("DD-MM-YYYY")
            : "N/A",
      },
    ],
    [mockDrillData]
  );

  return (
    <>
      <Collapse title="Mock Drill Schdule Details" isExpandable={isExpandable}>
        <Row className="d-flex  mb-2">
          {fields.map(({ name, key, isRequired, renderField }) => {
            const value = get(mockDrillData, key, "");
            return (
              <Col key={key} lg={6} className="mb-1">
                <Row>
                  <Col md={5}>{t(name)}:</Col>
                  <Col
                    md={7}
                    className="fw-semibold"
                    style={{ wordBreak: "break-word" }}
                  >
                    {renderField
                      ? renderField(value)
                      : get(mockDrillData, key, null) ??
                        (isRequired ? "-" : "N/A")}
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </Collapse>
    </>
  );
};

ViewMockScheduleData.propTypes = {
  mockDrillData: PropTypes.object,
  isExpandable: PropTypes.bool,
  accessCardHolderType: PropTypes.number,
  t: PropTypes.func,
};

export default withTranslation()(ViewMockScheduleData);
